<ns-dialog-content>
  <nes-heading tag="h1" size="3xl" class="mb-3">
    {{ "USER_DATA.FACE_IMAGE.TITLE" | translate }}
  </nes-heading>
  <div *ngIf="isUploading; else default" class="basicLoader"></div>
  <ng-template #default>
    <nes-text class="nes-mb-5" color="blue">
      {{ "USER_DATA.FACE_IMAGE.INFO" | translate }}
    </nes-text>

    <nes-text-list list-type="checked" size="base" color="blue">
      <nes-text-list-item
        *ngFor="let item of 'USER_DATA.FACE_IMAGE.IMAGE_CHECKLIST' | translate"
      >
        <span>{{ item }}</span>
      </nes-text-list-item>
    </nes-text-list>
    <ng-container *ngIf="hasFileSizeError">
      <p class="inlineNotification inlineNotification--alert">
        <i
          class="icon icon--alert icon--nsRed icon--inline inlineNotification__icon"
        ></i>
        <span class="inlineNotification__text">
          {{ "USER_DATA.FACE_IMAGE.ERROR.FILE_SIZE" | translate }}
        </span>
      </p>
    </ng-container>
    <ng-container *ngIf="hasFileTypeError">
      <p class="inlineNotification inlineNotification--alert">
        <i
          class="icon icon--alert icon--nsRed icon--inline inlineNotification__icon"
        ></i>
        <span class="inlineNotification__text">
          {{ "USER_DATA.FACE_IMAGE.ERROR.FILE_TYPE" | translate }}
        </span>
      </p>
    </ng-container>
  </ng-template>
</ns-dialog-content>

<ns-dialog-actions>
  <nes-button
    [disabled]="isUploading"
    (click)="cancel.emit()"
    [cypress]="'dialog_decline'"
    variant="secondary"
    type="button"
    class="nes-mr-5"
  >
    {{ "BUTTON.CANCEL" | translate }}
  </nes-button>
  <nes-button
    [loading]="isUploading"
    (nesOnClick)="fileInput.click()"
    [cypress]="'dialog_accept'"
    variant="primary"
    type="button"
  >
    {{ "USER_DATA.BUTTON.MAKE_PHOTO" | translate }}
  </nes-button>
</ns-dialog-actions>
<input
  #fileInput
  class="s-hidden"
  [cypress]="'upload_image'"
  type="file"
  (change)="onFileSelected($event)"
  accept="image/*"
/>
